import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ESidebarMode } from 'app/enums/sidebarmode.enum';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IChatUser } from 'app/interfaces/chatuser.interface';
import { IRecurrencyAttempt } from 'app/interfaces/recurrent-attempts.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { ChatService } from 'app/services/chat.service';
import { AppointmentSidebarService } from 'modules/appointments/services/appointment-sidebar.service';

@Component({
	selector: 'calendar-recurrency-attempt-modal',
	templateUrl: './calendar-recurrency-attempt-modal.component.html',
	styleUrls: ['./calendar-recurrency-attempt-modal.component.scss'],
})
export class CalendarRecurrencyAttemptModalComponent implements OnInit {
	@Input() isOpen = false;
	@Input() recurrencyAttempt: IRecurrencyAttempt;
	@Output() onClose = new EventEmitter();
	formattedDate = '';
	formattedMotive = '';
	formattedCard = '';

	constructor(
		public router: Router,
		public translateService: TranslateService,
		public atService: ActionTrackerService,
		public chatService: ChatService,
		public sidebarService: AppointmentSidebarService
	) {}

	ngOnInit(): void {
		this.formattedDate = this.getFormattedDate();
		this.formattedMotive = this.getFormattedMotive();
		this.formattedCard = this.getFormattedCard();
	}

	getFormattedMotive() {
		if (this.recurrencyAttempt.reason === 'ProfessionalHasNoAvailability') {
			return this.translateService.instant(
				'RECURRENCY_ATTEMPT.REASONS.UNAVAILABLE'
			);
		} else if (
			this.recurrencyAttempt.reason === 'ProfessionalHasBlockedAvailability' &&
			this.recurrencyAttempt.blockedType === 'Appointment'
		) {
			return this.translateService.instant(
				'RECURRENCY_ATTEMPT.REASONS.ONLINE_SESSION'
			);
		} else if (
			this.recurrencyAttempt.reason === 'ProfessionalHasBlockedAvailability' &&
			this.recurrencyAttempt.blockedType === 'BusySlot'
		) {
			return this.translateService.instant(
				'RECURRENCY_ATTEMPT.REASONS.PARTICULAR_EVENT'
			);
		}
	}

	getFormattedCard() {
		if (this.recurrencyAttempt.reason === 'ProfessionalHasNoAvailability') {
			return this.translateService.instant(
				'RECURRENCY_ATTEMPT.DETAILS_UNAVAILABLE'
			);
		} else if (
			this.recurrencyAttempt.reason === 'ProfessionalHasBlockedAvailability' &&
			this.recurrencyAttempt.blockedType === 'Appointment'
		) {
			return this.translateService.instant(
				'RECURRENCY_ATTEMPT.DETAILS_EVENTS',
				{ name: this.recurrencyAttempt.contactName }
			);
		} else if (
			this.recurrencyAttempt.reason === 'ProfessionalHasBlockedAvailability' &&
			this.recurrencyAttempt.blockedType === 'BusySlot'
		) {
			return this.translateService.instant(
				'RECURRENCY_ATTEMPT.DETAILS_BUSYSLOT'
			);
		}
	}

	getFormattedDate() {
		return this.recurrencyAttempt.luxonStartDate
			.setLocale('pt-BR')
			.toFormat("dd 'de' MMMM 'de' yyyy, HH:mm");
	}

	goToAvailabilities() {
		this.atService.eventTracker(
			SCOPE_TYPE.Caledar,
			SUBSCOPE_TYPE.RecurrencyAttempt,
			ITEM_TYPE.BtnAvailability,
			INTERACTION_TYPE.Click,
			{}
		);
		this.router.navigateByUrl('/availabilities');
	}

	goToContactPage() {
		this.atService.eventTracker(
			SCOPE_TYPE.Caledar,
			SUBSCOPE_TYPE.RecurrencyAttempt,
			ITEM_TYPE.BtnContact,
			INTERACTION_TYPE.Click,
			{}
		);
		this.router.navigateByUrl(`/contact/${this.recurrencyAttempt.contactId}`);
	}

	openChat() {
		this.atService.eventTracker(
			SCOPE_TYPE.Appointment,
			SUBSCOPE_TYPE.RecurrencyAttempt,
			ITEM_TYPE.BtnChat,
			INTERACTION_TYPE.Click,
			{}
		);
		const chatUser: IChatUser = {
			id: this.recurrencyAttempt.profileId,
			photoUrl: null,
			username: this.recurrencyAttempt.contactName,
			role: this.chatService.role,
		};
		this.chatService.startConversation(chatUser, 'recurrency-attempt-modal');
	}

	sendInvite() {
		this.atService.eventTracker(
			SCOPE_TYPE.Caledar,
			SUBSCOPE_TYPE.RecurrencyAttempt,
			ITEM_TYPE.BtnSchedule,
			INTERACTION_TYPE.Click,
			{}
		);
		this.sidebarService.setSidebar(true, {
			mode: ESidebarMode.New,
			date: new Date(),
			contactId: parseInt(this.recurrencyAttempt.contactId),
		});
		this.onClose.emit();
	}
}
